module.exports = __webpack_public_path__ + "img/computer.e8f67e4e.svg";